import Emitter from 'emitter-js'

export const emitter = new Emitter()